import { HStack, Link, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../hooks/useStores";
import ZoomIcon from "../../assets/images/zoom.png";
import { useEffect } from "react";

type Props = {
  next: () => any;
};

export const SupervisionedWorkoutsStep2: React.FC<Props> = observer(
  ({ next }) => {
    const { session } = useStores();

    // useEffect(() => {
    //   setTimeout(() => {
    //     window.open(
    //       session.supervisionedWorkoutStep2ZoomLink?.value || "",
    //       "_blank"
    //     );
    //     next();
    //   }, 1000);
    // }, []);

    console.log(session.supervisionedWorkoutStep2ZoomLink);

    return (
      <Stack
        justifyContent={"center"}
        flexWrap={"wrap"}
        alignContent={"center"}
        alignItems={"center"}
      >
        {session.supervisionedWorkoutStep2Message && (
          <Text fontSize="md" fontWeight={300} marginBottom={"0.5"}>
            {session.supervisionedWorkoutStep2Message.value}
          </Text>
        )}

        <HStack justifyContent="center" paddingTop="2rem">
          {session.supervisionedWorkoutStep2ZoomLink && (
            <Link
              href={session.supervisionedWorkoutStep2ZoomLink?.value || ""}
              isExternal
              // onClick={(e) => {
              //   e.preventDefault();
              //   window.open(
              //     session.supervisionedWorkoutStep2ZoomLink?.value || ""
              //   );
              // }}
            >
              <Stack alignContent="center" alignItems="center" paddingY="2rem">
                <span>Clicca qui per accedere alla diretta</span>
              </Stack>
            </Link>
          )}
        </HStack>
      </Stack>
    );
  }
);
